import { isMainThread } from 'node:worker_threads';
import {
  readSmallFileRangeSync,
  SMALL_FILE_RANGE_MAX_BYTES,
} from './read-small-file-range-async.js';
import type { ReadFileOptions } from './read-file-options.js';
import type { ReadFileResult } from './types.js';
import { resolveFileForReadOnMainThread } from './resolve-file-path.js';

export function isInteractiveMainThreadRead(options?: ReadFileOptions): boolean {
  return isMainThread && options?.skipInitialYield === true && options?.useResolvedSize === true;
}

export function readFileInteractiveOnMainThread(
  relativePath: string,
  startLine: number,
  endLine: number,
  lineOffset: number | undefined,
  lineChunkSize: number,
  sessionParentPath: string,
): ReadFileResult | { error: string } {
  const resolved = resolveFileForReadOnMainThread(relativePath, sessionParentPath);
  if ('error' in resolved) return resolved;
  const resolvedPath = resolved.path;
  const fileSize = resolved.size;

  if (fileSize > SMALL_FILE_RANGE_MAX_BYTES) {
    return { error: 'File too large for interactive read path' };
  }
  return readSmallFileRangeSync(
    resolvedPath,
    fileSize,
    startLine,
    endLine,
    lineOffset,
    lineChunkSize,
  );
}
